import { resolveEcomLocation } from './stores/useLocationsStore'
import { useSessionStore } from './stores/useSessionStore'
import { IDENTITY_CONTACT_EVENT } from './utils/contactIdentity'

type EventHandler = (data?: unknown) => void

class WidgetBridge {
  private handlers: Record<string, EventHandler[]> = {}

  on(event: string, handler: EventHandler): void {
    if (!this.handlers[event]) {
      this.handlers[event] = []
    }
    this.handlers[event].push(handler)
  }

  off(event: string, handler: EventHandler): void {
    const list = this.handlers[event]
    if (!list) return
    this.handlers[event] = list.filter((h) => h !== handler)
  }

  emit(event: string, data?: unknown): void {
    const list = this.handlers[event]
    if (!list) return
    for (const handler of list) {
      try {
        handler(data)
      } catch (err) {
        console.error(`[WidgetBridge] Error in handler for "${event}":`, err)
      }
    }
  }
}

export const widgetBridge = new WidgetBridge()

widgetBridge.on('setStoreLocation', (data) => {
  const query = data as { name?: string; id?: string; globalID?: string }
  const location = resolveEcomLocation(query)
  if (location) {
    useSessionStore.getState().setCurrentGlobalID(location.globalID)
  }
})

widgetBridge.on(IDENTITY_CONTACT_EVENT, (data) => {
  const payload = (data ?? {}) as { contactID?: string | null }
  const contactID =
    typeof payload.contactID === 'string' ? payload.contactID.trim() : payload.contactID
  useSessionStore.getState().setContactID(contactID || undefined, 'bridge')
})
